module.exports = __webpack_public_path__ + "img/404.2cb67f30.png";